import { BaseModel } from '../../shared/entities/base.model';
import {AnswerModel, AnswersTypeModel} from './answer.model';

export class QuestionModel extends BaseModel {
    id: number;
    uid: string;
    position: number;
    questionName: string;
    answerType: AnswersTypeModel = new AnswersTypeModel();
    answer: AnswerModel = new AnswerModel();
}
